import "../styles/bmr/shortcode-style.scss";
function run () {
  /*


  // Test input
  let age = 36;
  let gender = 1;

  let weightKG = 80;
  let heightCM = 180;

  let weightLBS = 150;
  let heightFT = 6;
  let heightIN = 2;

  // Test Calculations
  let bmr = 9.99 * weightKG + 6.25 * heightCM - 4.92 * age + ( gender === 1 ? 5 : -161 );

  // Total Calories Burned a Day Depending on Activity Level:
  console.log( bmr );
  console.log( bmr * 1.2 );
  console.log( bmr * 1.375 );
  console.log( bmr * 1.55 );
  console.log( bmr * 1.725 );
  console.log( bmr * 1.9 );
*/

  // Convert pound/foot/inch to KG/CM
  const poundIndex = 0.453592; // kilograms
  const footIndex = 30.48; // centimeters
  const inchIndex = 2.54; // centimeters

  const selector = "#bmr-calculator";

  const calculateButton = document.querySelector(
    selector + ' input[name="calculate"]'
  );

  const age = document.querySelector(selector + ' input[name="age"]');
  const gender = document.querySelector(selector + ' input[name="gender"]');

  const height = document.querySelector(selector + ' input[name="height"]');
  const heightFT = document.querySelector(selector + ' input[name="heightFT"]');
  const heightIN = document.querySelector(selector + ' input[name="heightIN"]');
  const heightCM = document.querySelector(selector + ' input[name="heightCM"]');

  const weight = document.querySelector(selector + ' input[name="weight"]');
  const weightLBS = document.querySelector(
    selector + ' input[name="weightLBS"]'
  );
  const weightKG = document.querySelector(selector + ' input[name="weightKG"]');

  // parse text(number) inputs
  document
    .querySelectorAll(selector + ' input[type="text"]')
    .forEach(function (input) {
      input.addEventListener("input", function (event) {
        event.target.value = event.target.value.replace(/[^\d.]/g, "");
        convertHeightAndWeight(event.target);
      });
    });

  gender.addEventListener("click", function () {
    checkRequiredFields();
  });

  // check input field values and enable/disable 'Calculate' button
  function checkRequiredFields() {
    let gender_is_checked = document.querySelector(
      selector + ' input[name="gender"]:checked'
    );
    if (age.value && height.value && weight.value && gender_is_checked) {
      calculateButton.disabled = false;
      return true;
    } else {
      calculateButton.disabled = true;
      return false;
    }
  }

  function convertHeightAndWeight(element) {
    // convert Height
    if (
      element.name === "heightCM" ||
      element.name === "heightFT" ||
      element.name === "heightIN"
    ) {
      height.value = "";
    }
    if (element.name === "heightCM" && element.value) {
      height.value = element.value;
    }
    if (
      (element.name === "heightFT" && heightFT.value) ||
      (element.name === "heightIN" && heightIN.value)
    ) {
      height.value = heightFT.value * footIndex + heightIN.value * inchIndex;
    }
    // convert Weight
    if (element.name === "weightKG" || element.name === "weightLBS") {
      weight.value = "";
    }
    if (element.name === "weightKG" && element.value) {
      weight.value = element.value;
    }
    if (element.name === "weightLBS" && weightLBS.value) {
      weight.value = weightLBS.value * poundIndex;
    }
    checkRequiredFields();
  }

  // show/hide Height and Weight fields depending on type
  document
    .querySelectorAll(
      selector +
      ' input[name="height-type"], ' +
      selector +
      ' input[name="weight-type"]'
    )
    .forEach(function (input) {
      input.addEventListener("change", function (event) {
        if (event.target.name === "height-type") {
          if (event.target.value === "ftin") {
            heightCM.setAttribute("class", "bmr-hidden");
            heightIN.setAttribute("class", "");
            heightFT.setAttribute("class", "");
          }
          if (event.target.value === "cm") {
            heightCM.setAttribute("class", "");
            heightIN.setAttribute("class", "bmr-hidden");
            heightFT.setAttribute("class", "bmr-hidden");
          }
        }
        if (event.target.name === "weight-type") {
          if (event.target.value === "lbs") {
            weightLBS.setAttribute("class", "");
            weightKG.setAttribute("class", "bmr-hidden");
          }
          if (event.target.value === "kg") {
            weightLBS.setAttribute("class", "bmr-hidden");
            weightKG.setAttribute("class", "");
          }
        }
      });
    });

  // submit form and calculate results
  calculateButton.addEventListener("click", function () {
    // check is empty
    if (!checkRequiredFields()) {
      alert("Please check input fields");
      return;
    }

    dataLayer.push({
      'event':'bmr_calculator_completion',
      'page_name':'bmr_calculator'
      });

    // calculate result
    let gender_value = document.querySelector(
      selector + ' input[name="gender"]:checked'
    ).value;

    let bmr =
      9.99 * weight.value +
      6.25 * height.value -
      4.92 * age.value +
      (gender_value === "male" ? 5 : -161);

    document.querySelector(
      selector + " .bmr-result-section .bmr-value"
    ).innerText = bmr.toFixed(0);

    // Total Calories Burned a Day Depending on Activity Level:
    document.querySelector(
      selector + " .bmr-result-section .bmr-activity-1"
    ).innerText = (bmr * 1.2).toFixed(0);
    document.querySelector(
      selector + " .bmr-result-section .bmr-activity-2"
    ).innerText = (bmr * 1.375).toFixed(0);
    document.querySelector(
      selector + " .bmr-result-section .bmr-activity-3"
    ).innerText = (bmr * 1.55).toFixed(0);
    document.querySelector(
      selector + " .bmr-result-section .bmr-activity-4"
    ).innerText = (bmr * 1.725).toFixed(0);
    document.querySelector(
      selector + " .bmr-result-section .bmr-activity-5"
    ).innerText = (bmr * 1.9).toFixed(0);

    // Show result container
    document
      .querySelector(selector + " .bmr-result-section")
      .classList.remove("bmr-hidden");
  });
};

if (document.readyState === "loading") {
  // El DOM aún no está cargado
  document.addEventListener("DOMContentLoaded", function () {
    console.log("El DOM está completamente cargado y listo.");
    run();
  });
} else {
  // El DOM ya se cargó
  console.log("El DOM ya estaba listo.");
  run();
}
